import React from "react";

export default function NotSupportedBrowser() {
    let chatLanguage = document.getElementById('chatLanguage');
    let lang = chatLanguage.getAttribute('data-language');

    return (
        <div className="sm-notSupportedBrowser">
            <span>{lang !== '' && lang.toLowerCase() === 'uk' || lang.toLowerCase() === 'ukr' || lang.toLowerCase() === 'ua' && window.LOCALE_UA_BROWSER_IE_NOT_SUPPORTED ? window.LOCALE_UA_BROWSER_IE_NOT_SUPPORTED : null}</span>
            <span>{lang !== '' && lang.toLowerCase() === 'ru' || lang.toLowerCase() === 'rus' && window.LOCALE_RU_BROWSER_IE_NOT_SUPPORTED ? window.LOCALE_RU_BROWSER_IE_NOT_SUPPORTED : null}</span>
            <span>{lang !== '' && lang.toLowerCase() === 'en' || lang.toLowerCase() === 'eng' && window.LOCALE_EN_BROWSER_IE_NOT_SUPPORTED ? window.LOCALE_EN_BROWSER_IE_NOT_SUPPORTED : null}</span>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/notSupportedBrowser/index.js